export const GET_REQUEST_SEASON_ROUNDS_START = "GET_REQUEST_SEASON_ROUNDS_START";
export const GET_REQUEST_SEASON_ROUNDS_SUCCESS = "GET_REQUEST_SEASON_ROUNDS_SUCCESS";
export const GET_REQUEST_SEASON_ROUNDS_ERROR = "GET_REQUEST_SEASON_ROUNDS_ERROR";

export const GET_REQUEST_FINISHED_ROUNDS_SORTED_NEW_START = "GET_REQUEST_FINISHED_ROUNDS_SORTED_NEW_START";
export const GET_REQUEST_FINISHED_ROUNDS_SORTED_NEW_SUCCESS = "GET_REQUEST_FINISHED_ROUNDS_SORTED_NEW_SUCCESS";
export const GET_REQUEST_FINISHED_ROUNDS_SORTED_NEW_ERROR = "GET_REQUEST_FINISHED_ROUNDS_SORTED_NEW_ERROR";
